import React, {useEffect, useRef, useState} from "react";
import {useParams} from "react-router";
import {CardService} from "./Service";

const UpdateCard = () => {
    const {id} = useParams();
    const service = new CardService();
    const [loading, setLoading] = useState(false);
    // Personal Info
    const [username, setUsername] = useState("");
    const [user, setUser] = useState("");
    const [orderId, setOrderId] = useState("");
    const [name, setName] = useState("");
    const [bio, setBio] = useState("");
    const [designation, setDesignation] = useState("");
    const [address, setAddress] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [profilePicUrl, setProfilePicUrl] = useState("");
    const [coverImageUrl, setCoverImageUrl] = useState("");
    const [profilePic, setProfilePic] = useState(null);
    const [coverImage, setCoverImage] = useState(null);


    // Contact Details
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [website, setWebsite] = useState("");

    // Social Links
    const [facebook, setFacebook] = useState("");
    const [instagram, setInstagram] = useState("");
    const [linkedin, setLinkedin] = useState("");
    const [twitter, setTwitter] = useState("");
    const [whatsapp, setWhatsapp] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        // setLoading(true);

    }

    const getDetails = async () => {
        const card = await service.get(id);
        if (card) {
            setUsername(card.username);
            setUser(card.user.name);
            setOrderId(`#${card.order.orderId}`);
            setName(card.personalInfo.name);
            setBio(card.personalInfo.bio ?? '');
            setDesignation(card.personalInfo.designation ?? '');
            setAddress(card.personalInfo.address ?? '');
            setBusinessName(card.personalInfo.businessName ?? '');
            setProfilePicUrl(card.personalInfo.profilePic);
            setCoverImageUrl(card.personalInfo.coverImage);
            setEmail(card.contactDetails.email ?? '');
            setPhone(card.contactDetails.phoneNumber ?? '');
            setWebsite(card.contactDetails.website ?? '');

            setFacebook(card.socialLinks.facebook ?? '');
            setInstagram(card.socialLinks.instagram ?? '');
            setLinkedin(card.socialLinks.linkedIn ?? '');
            setTwitter(card.socialLinks.twitter ?? '');
            setWhatsapp(card.socialLinks.whatsapp ?? '');
        }
    }

    useEffect(() => {
        getDetails();
    }, [id]);


    return (
        <>
            <form onSubmit={handleSubmit}>
                <div className="card mb-5">
                    <div className="card-header p-3">
                        <h5 className="card-title">Card Details</h5>
                    </div>
                    <div className="card-body">

                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Username <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="username" name="username"
                                           placeholder="Username" value={username}
                                           onChange={(e) => setUsername(e.target.value)} required={true}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Name <span
                                        className='text-danger'>(read only)</span></label>
                                    <input type="text" className="form-control" id="name" name="name" placeholder="Name"
                                           value={user}
                                           onChange={(e) => setUser(e.target.value)} required={true} readOnly={true}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Order Id <span
                                        className='text-danger'>(read only)</span></label>
                                    <input type="text" className="form-control" id="order-id" name="order-id"
                                           placeholder="Order Id"
                                           value={orderId}
                                           onChange={(e) => setOrderId(e.target.value)} required={true}
                                           readOnly={true}/>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="card mb-5">
                    <div className="card-header p-3">
                        <h5 className="card-title">Personal Info</h5>
                    </div>
                    <div className="card-body">

                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Name </label>
                                    <input type="text" className="form-control" id="name" name="name"
                                           placeholder="Name" value={name}
                                           onChange={(e) => setName(e.target.value)}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="designation" className="form-label">Designation</label>
                                    <input type="text" className="form-control" id="designation" name="designation"
                                           placeholder="Designation"
                                           value={designation}
                                           onChange={(e) => setDesignation(e.target.value)}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Business Name</label>
                                    <input type="text" className="form-control" id="business-name" name="business-name"
                                           placeholder="Business Name"
                                           value={businessName}
                                           onChange={(e) => setBusinessName(e.target.value)}/>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Profile Pic</label>
                                    <input type="file" className="form-control" id="profile-pic" name="profile-pic"
                                           placeholder="Profile Pic"
                                           onChange={(e) => {
                                               setProfilePic(e.target.files[0]);
                                           }}/>
                                    {profilePicUrl &&
                                        <a href={profilePicUrl} target="_blank">Click here to download current
                                            image</a>}
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Cover Image</label>
                                    <input type="file" className="form-control" id="cover-image" name="cover-image"
                                           placeholder="Cover Image"
                                           onChange={(e) => {
                                               setCoverImage(e.target.files[0]);
                                           }}/>
                                    {coverImageUrl &&
                                        <a href={coverImageUrl} target="_blank">Click here to download current
                                            image</a>}
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Bio</label>
                                    <textarea className="form-control" id="bio" name="bio" placeholder="Bio"
                                              value={bio}
                                              onChange={(e) => setBio(e.target.value)}/>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Address</label>
                                    <textarea className="form-control" id="address" name="address" placeholder="Address"
                                              value={address}
                                              onChange={(e) => setAddress(e.target.value)}/>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="card mb-5">
                    <div className="card-header p-3">
                        <h5 className="card-title">Contact Details</h5>
                    </div>
                    <div className="card-body">

                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Email </label>
                                    <input type="email" className="form-control" id="email" name="email"
                                           placeholder="Email" value={email}
                                           onChange={(e) => setEmail(e.target.value)}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="phone" className="form-label">Phone Number</label>
                                    <input type="text" className="form-control" id="phone" name="phone"
                                           placeholder="Phone Number"
                                           value={phone}
                                           onChange={(e) => setPhone(e.target.value)}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Website</label>
                                    <input type="text" className="form-control" id="website" name="website"
                                           placeholder="Website"
                                           value={website}
                                           onChange={(e) => setWebsite(e.target.value)}/>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="card mb-5">
                    <div className="card-header p-3">
                        <h5 className="card-title">Social Links</h5>
                    </div>
                    <div className="card-body">

                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Facebook </label>
                                    <input type="text" className="form-control" id="facebook" name="facebook"
                                           placeholder="Facebook" value={facebook}
                                           onChange={(e) => setFacebook(e.target.value)}/>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Instagram </label>
                                    <input type="text" className="form-control" id="instagram" name="instagram"
                                           placeholder="Instagram" value={instagram}
                                           onChange={(e) => setInstagram(e.target.value)}/>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">LinkedIn </label>
                                    <input type="text" className="form-control" id="LinkedIn" name="LinkedIn"
                                           placeholder="LinkedIn" value={linkedin}
                                           onChange={(e) => setLinkedin(e.target.value)}/>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Whatsapp </label>
                                    <input type="text" className="form-control" id="Whatsapp" name="Whatsapp"
                                           placeholder="Whatsapp" value={whatsapp}
                                           onChange={(e) => setWhatsapp(e.target.value)}/>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Whatsapp </label>
                                    <input type="text" className="form-control" id="Whatsapp" name="Whatsapp"
                                           placeholder="Whatsapp" value={whatsapp}
                                           onChange={(e) => setWhatsapp(e.target.value)}/>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </form>
        </>
    );
}


export default UpdateCard;
